import { getSubdomainCodeEmail } from '@functions/getSubDomainSalud';
import { getFcSegments } from '@services/catalogs/fc-dr-catalogs';
import { useEffect, useState } from "react"

const useOriginSegments = () => {
    const [ loading, setLoading ] = useState<boolean>(false)
    const [ segments, setSegments ] = useState<string[] | null>(null)

    const getSegments = async (appOrigin?:string) =>{
        setLoading(true)
        const origin = appOrigin ?? getSubdomainCodeEmail(true)
        try {
            const segmentsResponse = await getFcSegments(origin)
            setSegments(segmentsResponse)
        } catch (error) {
            setSegments([])
            console.error("get error to get segments", error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getSegments()
    }, [])

    return {segments, loading, getSegments:getSegments}
}
export default useOriginSegments
